import { AbstractFilter } from '../extensions/filter/compare/abstract-filter';

export interface FilterChange {
  readonly filter: readonly AbstractFilter<any>[];
  readonly column: string;
}
